var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeInventaireBlueLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74.11 76.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#152440;stroke-miterlimit:10;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M33,1h8.32l.61,1.41.4,2.12-.51,1.21.31,10.08c-.61,6.25,1.82,7.36,1.82,7.36,5.88,3.63,5.88,9,5.88,9L49.29,69c.61,7.66-12.78,6.15-12.78,6.15h1.32S24.45,76.61,25.06,69l-.51-36.8s0-5.34,5.88-9c0,0,2.43-1.11,1.82-7.36l.31-10.08-.51-1.21.41-2.12L33.07,1h8.31l.51,1.41"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.44,11.52H13.8l.47,1.13.31,1.69-.39,1,.23,8.06c-.46,5,1.4,5.89,1.4,5.89a9.19,9.19,0,0,1,4.5,7.17l-.39,29.43c.47,6.12-9.77,4.91-9.77,4.91h1S.92,72,1.39,65.86L1,36.43a9.19,9.19,0,0,1,4.5-7.17s1.86-.89,1.4-5.89l.23-8.06-.39-1,.31-1.69.47-1.13h6.36l.39,1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M60.39,20.82h6.28l.46.92.31,1.37-.38.79.23,6.56c-.46,4.07,1.38,4.79,1.38,4.79,4.44,2.37,4.44,5.85,4.44,5.85l-.38,23.95c.46,5-9.66,4-9.66,4h1s-10.13,1-9.67-4L54,41.1s0-3.48,4.45-5.85c0,0,1.84-.72,1.38-4.79l.23-6.56-.38-.79.3-1.37.46-.92h6.29l.38.92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeInventaireBlueLine);
export default __webpack_public_path__ + "static/media/icone_inventaire_blue_line.fd4c20b373b6fca7ceea5145eca3a743.svg";
export { ForwardRef as ReactComponent };